import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "styled-components";
import { HeroProps } from "../_shared";
import { StyledHeroContainer } from "../Hero.styles";
import { SimpleHeroInner, StyledArrowDown } from "./SimpleHero.styles";
import { Padding } from "../../design-system/Container/Container";

export interface SimpleHeroProps extends HeroProps {
  fullHeight?: boolean;
  contentWidth?: string;
}

export function SimpleHero({
  title,
  content,
  callToActions,
  belowCTA,
  contentWidth,
  fullHeight = true,
  ...props
}: SimpleHeroProps) {
  const theme = useTheme();
  const isDark = theme.theme.page === "dark";
  const refContainer = useRef(null);
  const [showArrowDown, setShowArrowDown] = useState(false);

  const handleResizeWindow = () => {
    if (refContainer.current) {
      const containerHeight = refContainer.current!["clientHeight"];
      // doing `refContainer.current!.clientHeight` causes an error on typescript, below is some info on this
      // https://bobbyhadz.com/blog/typescript-property-does-not-exist-on-type-never
      window.innerHeight < containerHeight
        ? setShowArrowDown(false)
        : setShowArrowDown(true);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResizeWindow);
    handleResizeWindow();
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  });

  const handleScrollDown = () => {
    if (refContainer.current) {
      window.scrollTo(0, refContainer.current!["clientHeight"] - 80);
    }
  };

  return (
    <StyledHeroContainer
      ref={refContainer}
      fullWidth
      padding={fullHeight ? Padding.horizontal : Padding.both}
      $fullHeight={fullHeight}
      className={isDark ? "dark-background" : ""}
      {...props}
    >
      <SimpleHeroInner $contentWidth={contentWidth}>
        {title}
        {content}
        {callToActions}
        {belowCTA}

        {showArrowDown && fullHeight && (
          <StyledArrowDown onClick={handleScrollDown} />
        )}
      </SimpleHeroInner>
    </StyledHeroContainer>
  );
}
